import { useParams } from "react-router-dom";
import learners from "../content/privacy/learners.json";
import test from "../content/privacy/tests.json";
import taxi from "../content/privacy/taxi-calculator.json";

const Privacy = () => {
  const { id } = useParams();
  const returnContent = () => {
    switch (id) {
      case "learners":
        return learners;
      case "tests":
        return test;
      case "taxi-calculator":
        return taxi;
      default:
        return null;
    }
  };
  return (
    <div className="justify-content-center align-items-center d-flex">
      {returnContent() && (
        <div className="container" style={{ width: 600 }}>
          <h1 className="mb-5 mt-5">{returnContent().title}</h1>
          {returnContent().content.map((section, index) => (
            <div key={index}>
              <h4>{section.header}</h4>
              <p>{section.body}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Privacy;
